export enum PAYMENT_TYPE {
    STRIPE = 'STRIPE',
    BRAINTREE = 'BRAINTREE',
    COUPON = 'COUPON',
    NONCE = 'NONCE',
    NONCE_ONE_TIME = 'NONCE_ONE_TIME',
    PAYPAL = 'PAYPAL',
    PREPAID = 'PREPAID',
}
